import { Injectable } from '@angular/core';
import { SelectItem } from '@r1-development/rps-shared-ui';
import { ExpressionType, RuleState, RuleValidationState } from '@r1-development/rule-management-api-client';

export const STATUS_CLASS = {
  'UP Opp Creation': 'null',
  Filtering: 'null',
  'Auto-Action': 'null',
  'Auto-Assignment': 'null',
  InProgress: 'badge InProgress',
  TestRunInProgress: 'badge TestRunInProgress',
  TestRunFailed: 'badge TestRunFailed',
  TestRunCompleted: 'badge TestRunCompleted',
  ApprovalPending: 'badge ApprovalPending',
  SentBackForRevision: 'badge SentBackForRevision',
  Approved: 'badge Approved',
  Expired: 'badge Expired',
  Deactivated: 'badge Deactivated',
  Deprecated: 'badge Deprecated',
};

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  statusClass = STATUS_CLASS;

  // tslint:disable-next-line:member-ordering
  hintOptions: any = {
    accountNumber: [],
    'accountMetaData.refTable': [],
    accountPaymentTrigger: [],
    accountPaymentTriggerDate: [],
    admitDate: [],
    'charges.amount': [],
    'charges.billingPhysician.code': [],
    'charges.billingPhysician.name': [],
    'charges.billingPhysician.npi': [],
    'charges.billingPhysician.specialty': [],
    'charges.cdm.cdmDescription': [],
    'charges.cdm.cdmNumber': [],
    'charges.codeDescription': [],
    'charges.cpt': [],
    'charges.departmentCode': [],
    'charges.departmentName': [],
    'charges.hcpcs': [],
    'charges.isAbstractCPT': [],
    'charges.isDuplicateCPT': [],
    'charges.isReversedCharge': [],
    'charges.modifier1': [],
    'charges.modifier2': [],
    'charges.modifier3': [],
    'charges.modifier4': [],
    'charges.performingPhysician.code': [],
    'charges.performingPhysician.name': [],
    'charges.performingPhysician.npi': [],
    'charges.performingPhysician.specialty': [],
    'charges.postingDate': [],
    'charges.quantity': [],
    'charges.revenueCode': [],
    'charges.sequence': [],
    'charges.serviceDate': [],
    'charges.systemId': [],
    'charges.transactionId': [],
    'claims.adjustmentAmount': [],
    'claims.billCode': [],
    'claims.billDate': [],
    'claims.billDateExternal': [],
    'claims.billStatus': [],
    'claims.billTypeName': [],
    'claims.bucketId': [],
    'claims.claimAmount': [],
    'claims.claimNumber': [],
    'claims.contractVerbiage': [],
    'claims.expectedPayment': [],
    'claims.facilityId': [],
    'claims.paidAmount': [],
    'claims.payerCode': [],
    'claims.payerName': [],
    'claims.payerPosition': [],
    'claims.typeOfBill': [],
    'clinicals.billedDRGFlag': [],
    'clinicals.conditionCode': [],
    'clinicals.drg.billedDRGFlag': [],
    'clinicals.drg.derivedDrgType': [],
    'clinicals.drg.derivedDrgVersion': [],
    'clinicals.drg.drgCode': [],
    'clinicals.drg.drgName': [],
    'clinicals.drg.drgType': [],
    'clinicals.drg.drgVersion': [],
    'clinicals.drg.drgWeight': [],
    'clinicals.drg.riskOfMortality': [],
    'clinicals.drg.severityOfIllness': [],
    'clinicals.occurrenceCodes.occurrenceCode': [],
    'clinicals.occurrenceCodes.occurrenceDate': [],
    'contractMetadata.contractGroupName': [],
    'contractMetadata.contractId': [],
    'contractMetadata.contractName': [],
    'contractMetadata.parentPayor': [],
    'contractMetadata.reportingPayor': [],
    dataLakeCorrelationId: [],
    dataLakeId: [],
    'diagnosis.code': [],
    'diagnosis.description': [],
    'diagnosis.onAdmission.admissionCode': [],
    'diagnosis.onAdmission.admissionCodeFlag': [],
    'diagnosis.sequence': [],
    'diagnosis.type': [],
    'diagnosis.version': [],
    dischargeDate: [],
    'encMstr.accountNumber': [],
    'encMstr.admitDate': [],
    'encMstr.admitLocation': [],
    'encMstr.admitSourceCode': [],
    'encMstr.admitSourceName': [],
    'encMstr.admitTypeCode': [],
    'encMstr.admitTypeName': [],
    'encMstr.dischargeDate': [],
    'encMstr.enterpriseMedicalRecordNumber': [],
    'encMstr.fromDate': [],
    'encMstr.hospitalServiceType': [],
    'encMstr.hospitalServiceTypeDescription': [],
    'encMstr.medicalRecordNumber': [],
    'encMstr.patientClass': [],
    'encMstr.patientClassName': [],
    'encMstr.patientId': [],
    'encMstr.patientTypeCode': [],
    'encMstr.patientTypeName': [],
    'encounter.accountNumber': [],
    'encounter.admitDate': [],
    'encounter.admitLocation': [],
    'encounter.admitSourceCode': [],
    'encounter.admitSourceName': [],
    'encounter.admitTypeCode': [],
    'encounter.admitTypeName': [],
    'encounter.attendingPhysicianCode': [],
    'encounter.attendingPhysicianName': [],
    'encounter.attendingPhysicianNPI': [],
    'encounter.codingStatusCode': [],
    'encounter.codingStatusName': [],
    'encounter.combinedAccounts.combinedDate': [],
    'encounter.combinedAccounts.sourceAccountNumber': [],
    'encounter.combinedAccounts.targetAccountNumber': [],
    'encounter.dischargeDate': [],
    'encounter.dischargeDepartment': [],
    'encounter.dischargeDepartmentCode': [],
    'encounter.dischargeDisposition': [],
    'encounter.dischargeDispositionDescription': [],
    'encounter.dischargeFacility': [],
    'encounter.ecdNumber': [],
    'encounter.guarantorAccountType': [],
    'encounter.hospitalServiceType': [],
    'encounter.hospitalServiceTypeDescription': [],
    'encounter.institutionalFlag': [],
    'encounter.isOpRecurringVisit': [],
    'encounter.motherAccountNumber': [],
    'encounter.patientClass': [],
    'encounter.patientClassName': [],
    'encounter.patientTypeCode': [],
    'encounter.patientTypeName': [],
    'encounter.placementCodes.code': [],
    'encounter.placementCodes.name': [],
    'encounter.placementCodes.placementDate': [],
    'encounter.placementCodes.placementType': [],
    'encounter.placementCodes.sequence': [],
    'encounter.placementCodes.user': [],
    'encounter.recurringIndicator': [],
    'encounter.referringPhysicianCode': [],
    'encounter.referringPhysicianName': [],
    'encounter.referringPhysicianNPI': [],
    'encounter.researchFlag': [],
    estPatiability: [],
    estPLCalcType: [],
    estPrimaryPayment: [],
    estSecondaryPayment: [],
    'facilityInfo.facilityAddress': [],
    'facilityInfo.facilityCity': [],
    'facilityInfo.facilityId': [],
    'facilityInfo.facilityName': [],
    'facilityInfo.facilityState': [],
    'facilityInfo.facilityType': [],
    'facilityInfo.facilityZip': [],
    facilityMnemonic: [],
    facilityOffset: [],
    federalTaxId: [],
    'financials.amount': [],
    'financials.billingIndicator': [],
    'financials.coInsurance': [],
    'financials.coPayment': [],
    'financials.deductible': [],
    'financials.depositDate': [],
    'financials.drgFromRemit': [],
    'financials.flags.badDebtWriteOff': [],
    'financials.flags.charityCareWriteOff': [],
    'financials.flags.patientDiscount': [],
    'financials.flags.patientPayment': [],
    'financials.invoiceNumber': [],
    'financials.nonCovered': [],
    'financials.patientResponsibility': [],
    'financials.payer.code': [],
    'financials.payer.financialClass': [],
    'financials.payer.name': [],
    'financials.payer.position': [],
    'financials.systemId': [],
    'financials.transaction.postDate': [],
    'financials.transaction.transactionCode': [],
    'financials.transaction.transactionCodeDescription': [],
    'financials.transaction.transactionDate': [],
    'financials.transaction.transactionId': [],
    'financials.transaction.transactionType': [],
    'financialSummary.amountTransferredToCollection': [],
    'financialSummary.badDebtBalance': [],
    'financialSummary.badDebtFlag': [],
    'financialSummary.billingIndicator': [],
    'financialSummary.collectorCode': [],
    'financialSummary.currentAgencyCode': [],
    'financialSummary.expectedReimbursement': [],
    'financialSummary.firstBilledDate': [],
    'financialSummary.lastInsurancePaymentDate': [],
    'financialSummary.medicarePayments': [],
    'financialSummary.mostRecentBillDate': [],
    'financialSummary.mostRecentBillStatus': [],
    'financialSummary.totalAccountBalance': [],
    'financialSummary.totalAdjustments': [],
    'financialSummary.totalCharges': [],
    'financialSummary.totalInsuranceAdjustments': [],
    'financialSummary.totalInsuranceBalance': [],
    'financialSummary.totalInsurancePayments': [],
    'financialSummary.totalPatientBalance': [],
    'financialSummary.totalPatientOtherAdjustments': [],
    'financialSummary.totalPatientPayments': [],
    'financialSummary.totalPatientRefund': [],
    'financialSummary.totalPayments': [],
    'financialSummary.zeroBalanceDate': [],
    healthSystemId: [],
    healthSystemName: [],
    inflowDate: [],
    'insurance.balance': [],
    'insurance.contractMappingKey': [],
    'insurance.financialClass': [],
    'insurance.financialClassDescription': [],
    'insurance.groupName': [],
    'insurance.groupNumber': [],
    'insurance.payerCode': [],
    'insurance.payerName': [],
    'insurance.payerPosition': [],
    'insurance.planCode': [],
    'insurance.planName': [],
    'insurance.policyNumber': [],
    isOOS: [],
    isOpenBalance: [],
    los: [],
    medicalRecordNumber: [],
    'medicarePricing.baseDRGReimbursement': [],
    'medicarePricing.CCN': [],
    'medicarePricing.CMSOutlierFlag': [],
    'medicarePricing.drgCode': [],
    'medicarePricing.MedicarePricingNotes': [],
    'medicarePricing.medicareXR': [],
    'medicarePricing.medicareXRType': [],
    'medicarePricing.OutlierExpected': [],
    'medicarePricing.specialPayReimbursement': [],
    'medicarePricing.transferReimbursement': [],
    npi: [],
    'OOS.isOOS': [],
    'OOS.serviceLine': [],
    'OOS.updatedDate': [],
    'opportunityPricing.accountNumber': [],
    'opportunityPricing.accountPaymentTrigger': [],
    'opportunityPricing.accountPaymentTriggerDate': [],
    'opportunityPricing.adjustmentLimitDate': [],
    'opportunityPricing.admitDate': [],
    'opportunityPricing.age': [],
    'opportunityPricing.arBalance': [],
    'opportunityPricing.auditLog': [],
    'opportunityPricing.billingLimitCOBDate': [],
    'opportunityPricing.billingLimitCorrectedClaimDate': [],
    'opportunityPricing.billingLimitDate': [],
    'opportunityPricing.clientExpected': [],
    'opportunityPricing.contractGroupName': [],
    'opportunityPricing.contractId': [],
    'opportunityPricing.contractMasterId': [],
    'opportunityPricing.contractName': [],
    'opportunityPricing.createdDate': [],
    'opportunityPricing.dischargeDate': [],
    'opportunityPricing.dueDate': [],
    'opportunityPricing.estNonPursuableWriteOff': [],
    'opportunityPricing.estPatiability': [],
    'opportunityPricing.estPLCalcType': [],
    'opportunityPricing.estPrimaryPayment': [],
    'opportunityPricing.estSecondaryPayment': [],
    'opportunityPricing.expected': [],
    'opportunityPricing.expectedType': [],
    'opportunityPricing.filtered': [],
    'opportunityPricing.filterId': [],
    'opportunityPricing.filterRuleMasterId': [],
    'opportunityPricing.fullDenial': [],
    'opportunityPricing.healthSystemName': [],
    'opportunityPricing.imeGme': [],
    'opportunityPricing.insurancePayment': [],
    'opportunityPricing.isEndState': [],
    'opportunityPricing.isHighDollar': [],
    'opportunityPricing.isOOS': [],
    'opportunityPricing.isOpportunity': [],
    'opportunityPricing.isQueueAssignedBefore': [],
    'opportunityPricing.isRush': [],
    'opportunityPricing.isSuppressed': [],
    'opportunityPricing.isWithClient': [],
    'opportunityPricing.kboxCorrelationId': [],
    'opportunityPricing.lastModifiedDate': [],
    'opportunityPricing.los': [],
    'opportunityPricing.medicaidNotes': [],
    'opportunityPricing.medicaidType': [],
    'opportunityPricing.medicaidXR': [],
    'opportunityPricing.medicareXR': [],
    'opportunityPricing.opportunityCategory': [],
    'opportunityPricing.opportunityId': [],
    'opportunityPricing.opportunityType': [],
    'opportunityPricing.opportunityValue': [],
    'opportunityPricing.opportunityXR': [],
    'opportunityPricing.parentPayor': [],
    'opportunityPricing.patientClass': [],
    'opportunityPricing.patientLiability': [],
    'opportunityPricing.paymentType': [],
    'opportunityPricing.paymentVariance': [],
    'opportunityPricing.paymentVariation': [],
    'opportunityPricing.payorName': [],
    'opportunityPricing.pricingComment': [],
    'opportunityPricing.pricingNotes': [],
    'opportunityPricing.nonRecurringPricingNotes': [],
    'opportunityPricing.providerName': [],
    'opportunityPricing.queueRuleMasterId': [],
    'opportunityPricing.rank': [],
    'opportunityPricing.reportingPayor': [],
    'opportunityPricing.retractionLimitDate': [],
    'opportunityPricing.ruleDescription': [],
    'opportunityPricing.ruleId': [],
    'opportunityPricing.ruleMasterId': [],
    'opportunityPricing.ruleName': [],
    'opportunityPricing.ruleSemanticId': [],
    'opportunityPricing.ruleSemanticMasterId': [],
    'opportunityPricing.runType': [],
    'opportunityPricing.serviceId': [],
    'opportunityPricing.serviceLine': [],
    'opportunityPricing.serviceLineId': [],
    'opportunityPricing.serviceName': [],
    'opportunityPricing.status': [],
    'opportunityPricing.timelyFilingDate': [],
    'opportunityPricing.totalCharges': [],
    'opportunityPricing.totalPayment': [],
    'opportunityPricing.workDriverDetails.actionId': [],
    'opportunityPricing.workDriverDetails.actionName': [],
    'opportunityPricing.workDriverDetails.assignedById': [],
    'opportunityPricing.workDriverDetails.assignedByName': [],
    'opportunityPricing.workDriverDetails.assignedName': [],
    'opportunityPricing.workDriverDetails.assignedTo': [],
    'opportunityPricing.workDriverDetails.categoryId': [],
    'opportunityPricing.workDriverDetails.categoryName': [],
    'opportunityPricing.workDriverDetails.classificationId': [],
    'opportunityPricing.workDriverDetails.classificationName': [],
    'opportunityPricing.workDriverDetails.closedById': [],
    'opportunityPricing.workDriverDetails.closedByName': [],
    'opportunityPricing.workDriverDetails.closureReason': [],
    'opportunityPricing.workDriverDetails.closureReasonId': [],
    'opportunityPricing.workDriverDetails.followUpDate': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.invoicedAmount': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.invoicedById': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.invoicedByName': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.invoicedDate': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.invoiceNumber': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.oppPaymentsReceived': [],
    'opportunityPricing.workDriverDetails.invoiceDetails.transactionId': [],
    'opportunityPricing.workDriverDetails.isWorkTriggered': [],
    'opportunityPricing.workDriverDetails.lastModifiedById': [],
    'opportunityPricing.workDriverDetails.lastModifiedByName': [],
    'opportunityPricing.workDriverDetails.lastModifiedDate': [],
    'opportunityPricing.workDriverDetails.lowConfidenceReason': [],
    'opportunityPricing.workDriverDetails.lowConfidenceReasonId': [],
    'opportunityPricing.workDriverDetails.opportunityFindings': [],
    'opportunityPricing.workDriverDetails.oppPaymentTriggerDates': [],
    'opportunityPricing.workDriverDetails.queueId': [],
    'opportunityPricing.workDriverDetails.queueName': [],
    'opportunityPricing.workDriverDetails.recoveryConfidence': [],
    'opportunityPricing.workDriverDetails.recoveryConfidenceId': [],
    'opportunityPricing.workDriverDetails.rootCauseId': [],
    'opportunityPricing.workDriverDetails.rootCauseName': [],
    'opportunityPricing.workDriverDetails.subActionId': [],
    'opportunityPricing.workDriverDetails.subActionName': [],
    'opportunityPricing.workDriverDetails.teamId': [],
    'opportunityPricing.workDriverDetails.teamName': [],
    'opportunityPricing.workDriverDetails.teamQueueId': [],
    'opportunityPricing.workDriverDetails.templateId': [],
    'opportunityPricing.workDriverDetails.templateName': [],
    'opportunityPricing.workQueueId': [],
    'opportunityPricing.xr1': [],
    'opportunityPricing.nonRecurringXR1': [],
    'patient.address.addressline1': [],
    'patient.address.addressline2': [],
    'patient.address.addressString': [],
    'patient.address.city': [],
    'patient.address.postalCode': [],
    'patient.address.postalCodeExtension': [],
    'patient.address.state': [],
    'patient.birthDate': [],
    'patient.employer': [],
    'patient.employerInfo.addressline1': [],
    'patient.employerInfo.addressline2': [],
    'patient.employerInfo.city': [],
    'patient.employerInfo.name': [],
    'patient.employerInfo.phoneNumber': [],
    'patient.employerInfo.postalCode': [],
    'patient.employerInfo.state': [],
    'patient.enterpriseMedicalRecordNumber': [],
    'patient.gender': [],
    'patient.guarantor.address.addressline1': [],
    'patient.guarantor.address.addressline2': [],
    'patient.guarantor.address.addressString': [],
    'patient.guarantor.address.city': [],
    'patient.guarantor.address.postalCode': [],
    'patient.guarantor.address.postalCodeExtension': [],
    'patient.guarantor.address.state': [],
    'patient.guarantor.birthDate': [],
    'patient.guarantor.gender': [],
    'patient.guarantor.name.firstName': [],
    'patient.guarantor.name.lastName': [],
    'patient.guarantor.name.middleName': [],
    'patient.guarantor.name.nameString': [],
    'patient.guarantor.phoneNumber': [],
    'patient.guarantor.relationship': [],
    'patient.guarantor.ssn': [],
    'patient.medicalRecordNumber': [],
    'patient.medicareHicNumber': [],
    'patient.mother.medicalRecordNumber': [],
    'patient.mother.name.firstName': [],
    'patient.mother.name.lastName': [],
    'patient.mother.name.middleName': [],
    'patient.mother.patientId': [],
    'patient.name.firstName': [],
    'patient.name.lastName': [],
    'patient.name.middleName': [],
    'patient.name.nameString': [],
    'patient.patientId': [],
    'patient.patientMaritalStatus': [],
    'patient.phoneNumber': [],
    'patient.ssn': [],
    patientClass: [],
    'procedures.code': [],
    'procedures.description': [],
    'procedures.performingPhysician.code': [],
    'procedures.performingPhysician.name': [],
    'procedures.performingPhysician.npi': [],
    'procedures.performingPhysician.specialty': [],
    'procedures.sequence': [],
    'procedures.serviceDate': [],
    'procedures.transactionId': [],
    'procedures.version': [],
    providerName: [],
    ptan: [],
    revintId: [],
  };

  serviceLineOptions: SelectItem[] = [
    { label: 'Underpayments', value: 1 },
    { label: 'Denials', value: 2 },
    { label: 'AR', value: 3 },
  ];

  ruleComplexityOptions: SelectItem[] = [
    { label: '\xa0', value: null },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
  ];

  dueDateBasisOptions: SelectItem[] = [
    { label: 'Billing Limit', value: 'Billing Limit' },
    { label: 'Billing Limit -  COB', value: 'Billing Limit - COB' },
    {
      label: 'Billing Limit - Corrected Claim',
      value: 'Billing Limit - Corrected Claim',
    },
    { label: 'Coding Completion Date', value: 'Coding Completion Date' },
    { label: 'Adjustment Limit', value: 'Adjustment Limit' },
    { label: 'Retraction Limit', value: 'Retraction Limit' },
  ];

  dueDateBasisDayModifierOptions: SelectItem[] = new Array(100).fill(null).map((_, i) => {
    return { label: i.toString(), value: i };
  });

  private identificationCommonCodeTypes = [
    {
      label: 'Procedure',
      value: 'procedure',
      actionTypes: [
        {
          label: 'Add',
          value: 'add',
          configs: [
            { label: 'Procedure', value: 'procedure', type: 'text' },
            { label: 'Sequence', value: 'sequence', type: 'dropdown' },
          ],
        },
        {
          label: 'Find and Replace',
          value: 'findAndReplace',
          configs: [{ label: 'Procedure', value: 'procedure' }],
          configsReplace: [{ label: 'Procedure', value: 'procedure' }],
        },
      ],
      disabled: false,
    },
    {
      label: 'Diagnosis',
      value: 'diagnosis',
      actionTypes: [
        {
          label: 'Add',
          value: 'add',
          configs: [
            { label: 'Diagnosis', value: 'diagnosis', type: 'text' },
            { label: 'Sequence', value: 'sequence', type: 'dropdown' },
          ],
        },
        {
          label: 'Find and Replace',
          value: 'findAndReplace',
          configs: [{ label: 'Diagnosis', value: 'diagnosis' }],
          configsReplace: [{ label: 'Diagnosis', value: 'diagnosis' }],
        },
      ],
      disabled: false,
    },
    {
      label: 'Opportunity Estimate',
      value: 'oppEstimate',
      actionTypes: [
        {
          label: 'Gross Opp Value',
          value: 'grossOppValue',
          configs: [{ label: 'Amount', value: 'amount', type: 'text' }],
        },
      ],
      disabled: false,
    },
    {
      label: 'Payment Variance',
      value: 'paymentVariance',
      actionTypes: [
        {
          value: 'paymentVariance',
        },
      ],
      disabled: false,
    },
  ];

  codeTypesMaster: any = {
    'BlueCard Opp Creation': [
      ...this.identificationCommonCodeTypes,
      {
        label: 'Contract',
        value: 'contractName',
        actionTypes: [
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'Contract Name', value: 'contractName', disabled: true }],
            configsReplace: [{ label: 'Contract Name', value: 'contractName', disabled: true }],
          },
        ],
      },
    ],
    'UP Opp Creation': [
      {
        label: 'Rev Code',
        value: 'revCode',
        actionTypes: [
          {
            label: 'Add',
            value: 'add',
            configs: [
              { label: 'Rev Code', value: 'revCode' },
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Quantity', value: 'quantity' },
              { label: 'Amount', value: 'amount' },
            ],
          },
          {
            label: 'Remove',
            value: 'remove',
            configs: [
              { label: 'Rev Code', value: 'revCode' },
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
          },
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [
              { label: 'Operator', value: 'operator' },
              { label: 'Rev Code', value: 'revCode' },
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
            configsReplace: [
              { label: 'Rev Code', value: 'revCode' },
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
          },
        ],
      },
      {
        label: 'CPT',
        value: 'cpt',
        actionTypes: [
          {
            label: 'Add',
            value: 'add',
            configs: [
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Quantity', value: 'quantity' },
              { label: 'Amount', value: 'amount' },
            ],
          },
          {
            label: 'Remove',
            value: 'remove',
            configs: [
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
          },
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
            configsReplace: [
              { label: 'CPT', value: 'cpt' },
              { label: 'Modifier', value: 'modifier' },
              { label: 'Amount', value: 'amount' },
            ],
          },
        ],
      },
      {
        label: 'Patient Class',
        value: 'patientClass',
        actionTypes: [
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'Patient Class', value: 'patientClass', disabled: true }],
            configsReplace: [
              {
                label: 'Patient Class',
                value: 'patientClass',
                type: 'dropdown',
                options: 'patientClassTypes',
              },
            ],
          },
        ],
      },
      {
        label: 'Contract',
        value: 'contractName',
        actionTypes: [
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'Contract Name', value: 'contractName', disabled: true }],
            configsReplace: [{ label: 'Contract Name', value: 'contractName', disabled: true }],
          },
        ],
      },
      {
        label: 'Procedure',
        value: 'procedure',
        actionTypes: [
          {
            label: 'Add',
            value: 'add',
            configs: [
              { label: 'Procedure', value: 'procedure' },
              { label: 'Quantity', value: 'quantity' },
            ],
          },
          {
            label: 'Remove',
            value: 'remove',
            configs: [{ label: 'Procedure', value: 'procedure' }],
          },
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'Procedure', value: 'procedure' }],
            configsReplace: [{ label: 'Procedure', value: 'procedure' }],
          },
        ],
      },
      {
        label: 'Diagnosis',
        value: 'diagnosis',
        actionTypes: [
          {
            label: 'Add',
            value: 'add',
            configs: [{ label: 'Diagnosis', value: 'diagnosis' }],
          },
          {
            label: 'Remove',
            value: 'remove',
            configs: [{ label: 'Diagnosis', value: 'diagnosis' }],
          },
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'Diagnosis', value: 'diagnosis' }],
            configsReplace: [{ label: 'Diagnosis', value: 'diagnosis' }],
          },
        ],
      },
      {
        label: 'MSDRG',
        value: 'msdrg',
        actionTypes: [
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [{ label: 'MSDRG', value: 'msdrg' }],
            configsReplace: [{ label: 'MSDRG', value: 'msdrg' }],
          },
        ],
      },
      {
        label: 'Payer',
        value: 'payer',
        actionTypes: [
          {
            label: 'Find and Replace',
            value: 'findAndReplace',
            configs: [
              {
                label: 'Find Payer',
                value: 'p-button-primary',
                placeholder: 'p-button-primary',
                disabled: true,
              },
            ],
            configsReplace: [
              {
                label: 'Replace Payer',
                value: 'p-button-secondary',
                placeholder: 'p-button-secondary',
                disabled: true,
              },
            ],
          },
        ],
      },
      {
        label: 'Opportunity Estimate',
        value: 'oppEstimate',
        actionTypes: [
          {
            label: 'Gross Opp Value',
            value: 'grossOppValue',
            configs: [{ label: 'Amount', value: 'amount' }],
          },
        ],
      },
    ],
    Filtering: [
      {
        label: 'Filtering',
        value: 'filtering',
        actionTypes: [
          { label: 'Write-Off', value: 'WRITE_OFF' },
          { label: 'Low Risk', value: 'LOW_RISK' },
        ],
      },
    ],
  };

  actionConfigsMaster: any = {
    WRITE_OFF: [],
    LOW_RISK: [],
  };

  newRule(): any {
    const ruleActionDefinition = {
      ruleActionId: 0,
      actionConfig: '[]',
      actionDefinition: '',
      actionType: '',
      actionComments: '',
      actionDescription: '',
      effectiveStartDate: null,
      effectiveEndDate: null,
      ruleAttributes: '{}',
    };
    const ruleDefinition = {
      ruleActionDefinition,
      comments: '',
      ruleDefinitionId: 0,
      ruleTitle: '',
      sqlType: 'spark',
    };
    const ruleMetaData = {
      ruleDescription: '',
      patientClass: '',
      payorType: '',
      priority: 0,
      ruleMetaDataId: 0,
      images: '',
    };
    const ruleWorkflow = {
      approvedBy: '',
      approvedDate: null,
      modifiedDate: null,
      createdBy: '',
      ruleWorkflowId: 0,
      workflowState: 0,
    };
    const ruleLibrary = {
      ruleDefinition,
      ruleMetaData,
      ruleWorkflow,
      ruleVersionId: 1.0,
      ruleId: 0,
      ruleSemanticId: null,
      ruleName: null,
      ruleType: '',
      isGlobal: true,
    };

    const ruleDetails = {
      tenants: [],
      tenantsExclude: [],
      isNew: true,
      ruleCategory: '',
      dueDateBasis: '',
      ruleMasterId: 0,
      active: false,
      editLog: '',
      productId: 1,
      ruleLibrary,
      hasApproved: false,
      ruleSemanticMasterId: '',
      ruleAuditHistory: [],
      ruleArtifact: [],
    };
    return ruleDetails;
  }

  newRuleDto(): any {
    const ruleDtoDetails = {
      id: '',
      name: '',
      description: '',
      isNew: true,
      definition: {
        filter: {
          additionalProp1: '',
          additionalProp2: '',
          additionalProp3: '',
        },
        sourceType: '',
        expressionType: ExpressionType.Custom,
        expression: 'SELECT ec.r1_id FROM hospital__encounter ec',
        additionalExpression: '',
      },
      ruleTypeId: '',
      opportunityTypeIds: [''],
      isGlobal: true,
      applicableClients: [],
      validationState: RuleValidationState.NotValidated,
      excludedClients: [],
      ruleState: RuleState.InProgress,
      approvedDate: new Date(),
      approvedById: '',
      approvedByName: '',
      comments: '',
      artifacts: [],
      additionalAttributes: {
        ruleAuthorReview: false,
        ruleComplexity: null,
        ruleEfficiency: '0',
      },
      actions: [],
      ruleVersion: 1,
    };
    return ruleDtoDetails;
  }
}
